/** MathJax の読み込みが完了したことを親 Window に送出 */
export function initChild() {
  const mathJaxSource = Array.from(
    // TODO: forEachに置き換え
    // @ts-expect-error - Array.fromの第一引数にNodeListOfの型が合わない
    document.querySelectorAll("script[src]"),
    (x: HTMLScriptElement) => x.src,
  ).filter((x: any) => /\/MathJax\.js/.test(x));

  if (mathJaxSource.length < 1) {
    console.log("MathJaxChannel.js initChild()", "no mathjax found");
    return;
  }

  const mathJaxEnded = new Promise<void>((resolve) => {
    MathJax.Hub!.Register.StartupHook("End", () => {
      document.dispatchEvent(new Event("MathJax:ended"));
      console.log("resolving");
      resolve();
    });
  });

  window.addEventListener(
    "message",
    (event) => {
      console.log("onmessage:child", event.origin);
      mathJaxEnded.then(() => {
        if (event.data === "MathJax:ping") {
          console.log("post to port", event.ports);
          // @ts-expect-error TS2532 -- noUncheckedIndexedAccess有効化以前から存在するコード
          event.ports[0].postMessage("MathJax:pong");
        }
        console.log("unknown", event.data);
      });
    },
    false,
  );
}
